import { url } from "./Config";

export const fullMediaUrl = (path) => (!path || /^https?:/.test(path) ? path || null : `${url}${path}`);
